<template>
<div class=" locking-msg-modal-wrapper">
  <TitleBaseBox
    :title="title"
    @close="close"
    @cancel="cancelClick"
    @confirm="confirmClick"
  >
    <div class=" locking-msg-content">
      <div class="message">
        <span class="mes-txt">{{ explain }}</span>
        <el-input 
          class="msg-input"
          v-model.trim="inputMsg" 
          maxlength="30"
          size="medium"
          show-word-limit
          :placeholder="placeholder"
        />
        <div class="msg-flex-tip">
          <i class="icon" />
          <span class="mes-tip">{{ tip }}</span>
        </div>
      </div>
    </div>
  </TitleBaseBox>
</div>
</template>

<script>
import TitleBaseBox from '@/views/zhiji/bComponents/TitleBaseBox.vue';
import i18n from "@/i18n";

export default {
  name: 'LockingQuestionModal',
  components: {
    TitleBaseBox,
  },
  props: {
    data: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      inputMsg: '',
    };
  },
  computed: {
    title() {
      return this.$t("zhiji.knowlege.lockingQuestionModal.title");
    },
    explain() {
      return this.$t("zhiji.knowlege.lockingQuestionModal.explain");
    },
    placeholder() {
      return this.$t("zhiji.knowlege.lockingQuestionModal.placeholder");
    },
    tip() {
      return this.$t("zhiji.knowlege.lockingQuestionModal.tip");
    }
  },
  mounted(){
    this.inputMsg = this.data.inputMsg;
  },
  methods: {
    close () {
      this.$emit('closeModal');
      this.data.colseHandle && this.data.colseHandle.apply(null);
    },
    cancelClick () {
      this.data.cancel && this.data.cancel.apply(null);
    },
    confirmClick () {
      if (!this.inputMsg) {
        this.$store.dispatch("zhiji/showModal", {
          type: "MessageModal",
          data: {
            type: "error",
            message: i18n.t("zhiji.knowlege.lockingQuestionModal.unlockEmptTip"),
          },
        });
        return;
      }
      this.data.confirm && this.data.confirm.call(null,this.inputMsg);
      this.close();
    },
  },
};
</script>

<style lang="less" scoped>
.locking-msg-modal-wrapper {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    
    .locking-msg-content {
        width: 460px;
        font-size: 16px;
        box-sizing: border-box;

        .message {
            position: relative;
            display: flex;
            flex-direction: column;
            /deep/ .el-input .el-input__inner {
              height: 45px;
              font-size: 16px;
            }
        }

        .icon {
            display: inline-block;
            width: 22px;
            height: 22px;
            margin-right: 10px;
            vertical-align: text-bottom;
            flex-shrink: 0;
            flex-grow: 0;
            background: url("@{zhijiStaticImagePath}i-tip.png") no-repeat;
        }

        .mes-txt{
            color: #000;
            line-height: 27px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-pack: center;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            max-height: 106px;
        }

        .msg-input {
          margin: 13px 0;
          /deep/input {
            padding-right: 55px;
          }
        }

        .msg-flex-tip {
            display: flex;
            align-items: center;
            .mes-tip {
              color: #999;
              font-size: 12px;
            }
        }
    }
}
</style>
